<div class="container" *ngIf="paymentData">
  <!--Account Info redirect to dashboard page-->
  <div class="acc-info-btn">
    <gds-utility-action
      [data]="{
            icon: {
            iconName: 'left-arrow-v2'
            },
            label: pageLabels?.['address.backCTA'],
            type: 'left-arrow-v2',
            disabled: false
            }"
      (click)="bacToAccInfo()"
    ></gds-utility-action>
  </div>
  <gds-spacer classes="spacer-70"></gds-spacer>
  <!--Address heading-->
  <gds-heading
    [data]="{
        heading: pageLabels?.['paymentInfo.heading'] ?? 'Payment Info'
      }"
    class="A3-W6"
  >
  </gds-heading>
  <!--Address description-->

  <ng-container *ngIf="paymentData.length > 0">
    <gds-spacer classes="spacer-70"></gds-spacer>
    <!--Address list card-->
    <div
      class="card card-container"
      tabindex="0"
      *ngFor="let card of paymentData"
    >
      <div class="payment-card">
        <gds-body
          [data]="{
                description: card?.is_primary ? pageLabels?.['paymentInfo.primaryCreditCard'] : pageLabels?.['paymentInfo.creditCard']
              }"
          class="B1-W4"
        ></gds-body>
        <div class="edit-cta">
          <!--Address list editCTA navigate to edit address page-->
          <gds-button
            [data]="{
                type: 'tertiary',
                href: '',
                label: pageLabels?.['deleteAcc.delete'],
                disabled: false,
                target: ''
              }"
            (buttonClicked)="editPaymentInfo(card)"
          >
          </gds-button>
        </div>
      </div>
      <div>
        <gds-spacer classes="spacer-30"></gds-spacer>
        <div class="payment-card-number">
          <div
            class="A6-W4 adventure"
            [attr.aria-label]="
            pageLabels?.['cardType.'+card?.issuer_code] +
            pageLabels?.['paymentInfo.card'] +
            card?.last_four_digits
          "
          >
            <span class="right-padding">
              {{
                pageLabels?.['cardType.'+showPrimaryCard?.issuer_code]
              }}
            </span>
          </div>
          <div class="A6-W4 adventure">
            <span *ngFor="let n of numSequence(10)">&bull;</span>
            <span>{{ card?.last_four_digits }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="paymentData.length === 0">
    <gds-spacer classes="spacer-70"></gds-spacer>
    <div class="card" tabindex="0">
      <gds-body
        [data]="{
                description:  pageLabels?.['paymentInfo.emptyCreditCard']
              }"
        class="B1-W4"
      ></gds-body>
    </div>
  </ng-container>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <gds-loading
    *ngIf="showLoader"
    [data]="{
    label: pageLabels?.['com.upr.general.loading.title'] 
  }"
  >
  </gds-loading>
</div>
